"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGraphSchemaCatalog = void 0;
const nodeLayer_1 = require("./nodeLayer");
const uiNodes_1 = require("./uiNodes/uiNodes");
/**
 * Build the catalog from the live registry.
 *
 * `primitiveOnly` (default true) restricts the tape nodes to the PRIMITIVE
 * layer — the CA-free surface AgentV authors against in Phase 1. Operation
 * nodes are always included: they are domain-agnostic transforms with no
 * artifact-type layer. The `db_node` (Monitor-mode read-only node) is excluded —
 * it is not an authoring primitive.
 */
const getGraphSchemaCatalog = ({ primitiveOnly = true, } = {}) => {
    const operations = [];
    const tapes = [];
    for (const node of uiNodes_1.uiNodes) {
        if (node.isOperation) {
            operations.push({
                kind: 'operation',
                nodeType: node.nodeType,
                label: node.nodeTypeText,
                operationType: node.operationType,
                configSchema: node.getJsonSchema(),
            });
            continue;
        }
        // Tape (file) node. `db_node` is the only non-operation node without an
        // `artifactType`; skip it (not an authoring primitive).
        if (node.nodeType === 'db_node') {
            continue;
        }
        const layer = (0, nodeLayer_1.isPrimitiveNodeType)(node.artifactType) ? 'primitive' : 'ca';
        if (primitiveOnly && layer !== 'primitive') {
            continue;
        }
        tapes.push({
            kind: 'tape',
            nodeType: node.nodeType,
            label: node.nodeTypeText,
            artifactType: node.artifactType,
            layer,
            isRaw: node.isRaw,
            isFinal: node.isFinal,
            configSchema: node.getJsonSchema(),
        });
    }
    return { operations, tapes };
};
exports.getGraphSchemaCatalog = getGraphSchemaCatalog;
//# sourceMappingURL=graphSchemaCatalog.js.map